import React, { useEffect, useRef, useState } from 'react';
import * as R from 'ramda';
import BrandedLoading from './BrandedLoading';
import withDashboard from '@/containers/Dashboard/withDashboard';

const FADE_OUT_MS = 400;

function SplashScreenComponent({ splashScreenLoading }: any) {
  const [visible, setVisible] = useState(false);
  const [fadingOut, setFadingOut] = useState(false);
  const fadeTimerRef = useRef<number | null>(null);

  // Hand off from the HTML initial-loader to the React splash:
  // mark `app-loaded` on next animation frame so the React tree has a
  // chance to paint first. This avoids the white flash that happened
  // when the initial-loader hid before the React splash was on screen.
  useEffect(() => {
    const id = window.requestAnimationFrame(() => {
      document.body.classList.add('app-loaded');
    });
    return () => window.cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    if (splashScreenLoading) {
      if (fadeTimerRef.current) {
        window.clearTimeout(fadeTimerRef.current);
        fadeTimerRef.current = null;
      }
      setVisible(true);
      setFadingOut(false);
      return;
    }

    if (visible) {
      setFadingOut(true);
      fadeTimerRef.current = window.setTimeout(() => {
        setVisible(false);
        setFadingOut(false);
        fadeTimerRef.current = null;
      }, FADE_OUT_MS);
    }

    return () => {
      if (fadeTimerRef.current) {
        window.clearTimeout(fadeTimerRef.current);
        fadeTimerRef.current = null;
      }
    };
  }, [splashScreenLoading, visible]);

  if (!visible) return null;

  return (
    <BrandedLoading
      fullscreen
      className={fadingOut ? 'branded-loading--fading-out' : undefined}
    />
  );
}

export const SplashScreen = R.compose(
  withDashboard(({ splashScreenLoading }: any) => ({
    splashScreenLoading,
  })),
)(SplashScreenComponent);
